/**
 * Toast — single toast notification component.
 * Used by ToastContainer for toasts from Admin pages.
 */
interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
}

export function Toast({ message, type, onClose }: ToastProps) {
  const bgMap = {
    success: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-200',
    error: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-200',
    info: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200',
  };

  return (
    <div
      className={`toast-notification flex items-center gap-2 px-4 py-3 rounded-lg border shadow-lg ${bgMap[type]} max-w-sm`}
      role="status"
      aria-live="polite"
    >
      <span className="flex-1 text-sm">{message}</span>
      <button onClick={onClose} className="ml-4 opacity-70 hover:opacity-100" aria-label="Close notification">
        ✕
      </button>
    </div>
  );
}
